import Box from "@mui/material/Box";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import { invalidateBroadcastDetailsQuery } from "entities/broadcasts/queries/useBroadcastDetailsQuery";
import { Status } from "entities/broadcasts/types";
import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useBroadcastsPage } from "../../context";
import { BroadcastDetailsProvider, useBroadcastDetails } from "./context";
import Actions from "./sections/Actions";
import General from "./sections/General";
import Scheduling from "./sections/Scheduling";
import UserSegmentation from "./sections/UserSegmentation";
import { StyledButton } from "./styled";

const BroadcastDetailsContainer: FC = () => (
  <BroadcastDetailsProvider>
    <BroadcastDetails />
  </BroadcastDetailsProvider>
);

const BroadcastDetails: FC = () => {
  const { broadcastDetailsDrawer } = useBroadcastsPage();
  const {
    broadcastStatus,
    scheduledAt,
    isSubmittingBroadcast,
    isDisabledSubmitButton,
    isDisabledDraftButton,
    onSaveBroadcastDetails,
    onCloseDrawer,
  } = useBroadcastDetails();

  const isVisibleActionButtons = broadcastStatus !== Status.Sent;

  const writeAccess = useRolePermission("broadcasts:write");

  const determineStatus = () => {
    if (
      (!broadcastDetailsDrawer.drawerDetails?.id && scheduledAt?.length) ||
      (broadcastDetailsDrawer.drawerDetails?.id && scheduledAt?.length)
    ) {
      return Status.Scheduled;
    }
    return Status.Sent;
  };

  return (
    <Drawer
      title={
        !broadcastDetailsDrawer.drawerDetails ? "Create Broadcast" : "Broadcast"
      }
      isOpen={broadcastDetailsDrawer.isOpen}
      onCloseDrawer={() => {
        invalidateBroadcastDetailsQuery(
          broadcastDetailsDrawer.drawerDetails?.id || "",
        );
        onCloseDrawer();
      }}
      width={640}
      headingRight={
        writeAccess.allowed &&
        isVisibleActionButtons && (
          <Box>
            <StyledButton
              title="Save as Draft"
              size="small"
              onClick={() => onSaveBroadcastDetails(Status.Draft)}
              disabled={isDisabledDraftButton}
              loading={isSubmittingBroadcast}
            />
            <StyledButton
              title="Save and Schedule"
              size="small"
              onClick={() => onSaveBroadcastDetails(determineStatus())}
              disabled={isDisabledSubmitButton}
              loading={isSubmittingBroadcast}
            />
          </Box>
        )
      }
    >
      <UserSegmentation />
      <Scheduling />
      <General />
      <Actions />
    </Drawer>
  );
};

export default BroadcastDetailsContainer;
